module.exports = __webpack_public_path__ + "static/media/iphone-box-view.e22eab73.jpg";